import api from './api';

export const questionnaireApi = {
  createQuestionnaire: (version, content) => 
    api.post('/api/questionnaires/', { version, content }),
  
  getUserQuestionnaires: (version = null) => 
    api.get('/api/questionnaires/', { params: version ? { version } : {} }),
  
  getQuestionnaireById: (questionnaireId) => 
    api.get(`/api/questionnaires/${questionnaireId}`),
  
  updateQuestionnaire: (questionnaireId, content) => 
    api.put(`/api/questionnaires/${questionnaireId}`, { content })
};